// Module
var code = "<div class=\"gc-preloader\"></div>";
// Exports
export default code;